@if (options(); as opts) {
  <app-modal-v2
    [open]="true"
    [title]="modalTitle()"
    titleColorClass="text-primary"
    [allowOutsideClick]="false"
    [showCloseButton]="false"
    [showFooterSeparator]="false"
    (closed)="close()"
  >
    <div
      class="flex flex-col items-center gap-4 pt-6 text-center"
      [class.pb-2]="step() !== 'loading' || opts.loadingStopText"
      [class.pb-6]="step() === 'loading' && !opts.loadingStopText"
      role="status"
    >
      @switch (step()) {
        @case ('loading') {
          <app-animated-icon [type]="loadingIcon()" />
          <div class="flex w-full flex-col items-center gap-1.5">
            <p class="w-full text-lg font-medium text-exlib-text dark:text-sidebar-text-dark">
              {{ loadingContent().message }}
            </p>
            @if (loadingContent().description) {
              <p class="max-w-72 whitespace-pre-line text-sm text-muted dark:text-muted-dark">
                {{ loadingContent().description }}
              </p>
            }
          </div>
        }
        @case ('success') {
          <app-animated-icon type="check" />
          <div class="flex flex-col items-center gap-1.5">
            <p class="text-lg font-medium text-exlib-text dark:text-sidebar-text-dark">
              {{ successContent().message }}
            </p>
            @if (successContent().description) {
              <p class="max-w-72 whitespace-pre-line text-sm text-muted dark:text-muted-dark">
                {{ successContent().description }}
              </p>
            }
          </div>
        }
        @case ('failed') {
          <app-animated-icon type="error" />
          <div class="flex flex-col items-center gap-1.5">
            <p class="text-lg font-medium text-exlib-text dark:text-sidebar-text-dark">
              {{ failedContent().message }}
            </p>
            @if (failedContent().description) {
              <p class="max-h-48 max-w-72 overflow-y-auto whitespace-pre-line text-sm text-muted dark:text-muted-dark">
                {{ failedContent().description }}
              </p>
            }
          </div>
        }
        @default {
          @if (opts.animatedIcon; as animatedIconType) {
            <app-animated-icon [type]="animatedIconType" />
          } @else if (opts.iconName; as iconName) {
            <app-icon
              [name]="iconName"
              class="text-primary"
              [width]="opts.iconWidth"
              [height]="opts.iconHeight"
              [strokeWidth]="6"
            />
          }
          <div class="flex flex-col items-center gap-1.5">
            <p class="max-w-80 text-lg font-medium text-exlib-text dark:text-sidebar-text-dark">
              {{ opts.message }}
            </p>
            @if (opts.description) {
              <p class="whitespace-pre-line text-sm text-muted dark:text-muted-dark">{{ opts.description }}</p>
            }
          </div>
          @if (opts.input; as input) {
            <div class="flex w-full max-w-80 flex-col gap-1.5 text-left" (keydown.enter)="submit()">
              <div class="relative flex w-full items-center">
                <app-input
                  class="block w-full [&_input::-webkit-calendar-picker-indicator]:absolute [&_input::-webkit-calendar-picker-indicator]:inset-0 [&_input::-webkit-calendar-picker-indicator]:h-full [&_input::-webkit-calendar-picker-indicator]:w-full [&_input::-webkit-calendar-picker-indicator]:cursor-pointer [&_input::-webkit-calendar-picker-indicator]:opacity-0 [&_input]:relative"
                  [type]="input.type"
                  [value]="inputValue()"
                  [placeholder]="input.placeholder"
                  [min]="input.min"
                  (valueChange)="onInput($event)"
                />
                @if (input.type === 'date') {
                  <app-icon name="calendar" class="pointer-events-none absolute right-4 text-primary" />
                }
              </div>
              @if (inputError(); as error) {
                <p class="text-xs text-danger">{{ error }}</p>
              }
            </div>
          }
        }
      }
    </div>

    @if (step() !== 'loading' || opts.loadingStopText) {
      <div modal-footer class="flex w-full items-center justify-center gap-3">
        @switch (step()) {
          @case ('success') {
            <app-button (click)="close()">OK</app-button>
          }
          @case ('failed') {
            <app-button variant="secondary" (click)="close()">Close</app-button>
            @if (canRetry()) {
              <app-button (click)="submit()">{{ opts.retryText }}</app-button>
            }
          }
          @case ('loading') {
            <app-button variant="secondary" (click)="stop()">{{ opts.loadingStopText }}</app-button>
          }
          @case ('confirm') {
            @for (button of opts.buttonOrder; track button) {
              @switch (button) {
                @case ('cancel') {
                  @if (opts.showCancel) {
                    <app-button variant="secondary" (click)="close()">{{ opts.cancelText }}</app-button>
                  }
                }
                @case ('deny') {
                  @if (opts.denyText) {
                    <app-button variant="danger" (click)="deny()">{{ opts.denyText }}</app-button>
                  }
                }
                @case ('confirm') {
                  <app-button [variant]="opts.confirmVariant" (click)="submit()">{{ opts.confirmText }}</app-button>
                }
              }
            }
          }
        }
      </div>
    }
  </app-modal-v2>
}
